(function (angular) {
	'use strict';

	angular.module('newsFeedModule', [
		'coreModule',
		'mediaGalleryModule'
	]);
})(window.angular);